<template>
    <CustomPage url="catalog" />
</template>

<script>
import CustomPage from '../_.vue'
import { GET_META } from '@@/graphQL/web'

export default {
  name: 'CatalogPage',

  components: {
    CustomPage
  },

  layout: 'custom',

  apollo: {
    metaBySlug: {
      query: GET_META,
      variables () {
        return {
          // @ts-ignore
          route: this.productGroupSlug ? 'catalog' : 'page',
          siteCode: this.$store.state.siteCode,
          // @ts-ignore
          slug: this.productGroupSlug || 'catalog'
        }
      }
    }
  },

  data: () => ({
    metaBySlug: {
      title: '',
      description: '',
      alt: ''
    }
  }),

  head () {
    return {
      title: this.metaBySlug?.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.metaBySlug?.description
        }
      ]
    }
  },

  computed: {
    productGroupSlug () {
      return this.$route.params.product_group_slug
    }
  }
}
</script>
